import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DesignComponent } from './design.component';
import { GptComponent } from './gpt/gpt.component';
import { ShoppableImageComponent } from './shoppable-image/shoppable-image.component';
import { BuyCreditsModalComponent } from './gpt/buy-credits-modal/buy-credits-modal.component';
import { RenderComponent } from './gpt/render/render.component';
import { AdminGuard } from '../shared/services/admin/admin.guard';
import { DesignerProfileComponent } from './designer-profile/designer-profile.component';
import { GiftCheckoutComponent } from './gift-checkout/gift-checkout.component';
import { GiftOrderConfirmationComponent } from './gift-order-confirmation/gift-order-confirmation.component';

const routes: Routes = [
  {
    path: '',
    component: DesignComponent
  },
  {
    path: ':designerId',
    component: DesignerProfileComponent
  },
  {
    path: 'gpt',
    component: GptComponent
  },
  {
    path: 'gpt/renders',
    component: RenderComponent
  },
  {
    path: 'gpt/:room-:style-:id',
    component: ShoppableImageComponent
  },
  {
    path: 'buy-credits',
    component: BuyCreditsModalComponent
  },
    {
    path: 'gift/checkout',
    component: GiftCheckoutComponent
  },
   {
    path: 'gift/order/:id',
    component: GiftOrderConfirmationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DesignRoutingModule { }
